module.exports = ".container {\n  padding-left: 115px; }\n\n.conf-section {\n  margin-top: 10px;\n  padding-left: 115px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/account/reset-password/reset-password.component.scss
// module id = ./src/app/pages/account/reset-password/reset-password.component.scss
// module chunks = main